export const ZAROR_LOGO_PATH = '/zaror-logo.png';
